// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  color: #3D1818;
}

.winery-header {
  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);
  color: #FAF6E7;
  padding: 80px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-bottom: 4px solid #D7B899;
  box-shadow: 0 8px 32px rgba(61, 24, 24, 0.15);
}

.winery-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, #E9A6A1 0%, transparent 60%), radial-gradient(circle at 80% 20%, #D7B899 0%, transparent 60%);
  opacity: 0.15;
}

.header-photo-section {
  position: relative;
  width: 100%;
  height: 380px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px; /* Add small margin for visual separation from navbar */
}

.header-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 60%; /* Lifted higher */
}

.header-photo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 68%; /* Static position for fallback */
  z-index: 1;
  transition: opacity 0.8s ease-in-out;
}

.header-photo.hidden {
  opacity: 0;
  pointer-events: none;
}

.header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  text-align: center;
}

.header-logo {
  height: 96px;
  width: auto;
  max-width: 480px;
  margin: 50px 0 50px 0;
  filter: brightness(0) saturate(100%) invert(95%) sepia(8%) saturate(624%) hue-rotate(333deg) brightness(102%) contrast(92%);
  transition: filter 0.3s ease;
}

.header-overlay h1 {
  font-size: 2.56rem;
  color: #FAF6E7;
  text-shadow: 0 4px 24px #3D1818, 0 1px 0 #7B2323;
  margin: 0 0 18px 0;
  letter-spacing: 4px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 300;
  text-transform: uppercase;
}

.header-overlay p {
  font-size: 1.5rem;
  color: #F7E9D2;
  text-shadow: 0 2px 8px #3D1818;
  font-weight: 300;
  letter-spacing: 2px;
  margin: 0;
  text-transform: uppercase;
  font-family: Arial, Helvetica, sans-serif;
}

.header-photo-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.header-photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: linear-gradient(180deg, rgba(61,24,24,0.25) 0%, rgba(123,35,35,0.25) 100%); */
  background: linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.18) 100%);
}

.header-content {
  position: relative;
  z-index: 3;
  text-align: center;
}

.header-content h1 {
  font-size: 3.2rem;
  color: #FAF6E7;
  text-shadow: 0 4px 24px #3D1818, 0 1px 0 #7B2323;
  margin-bottom: 18px;
  letter-spacing: 4px;
  font-family: 'Playfair Display', serif;
  font-weight: 400;
}

.header-content p {
  font-size: 1.25rem;
  color: #F7E9D2;
  text-shadow: 0 2px 8px #3D1818;
  font-weight: 300;
  letter-spacing: 2px;
  margin: 0;
  text-transform: uppercase;
}

/* About Us Section */
.about-section {
  padding: 60px 20px;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  min-height: 100vh;
}

/* Each subsection with text and image */
.about-subsection {
  max-width: 1200px;
  margin: 0 auto 80px auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.about-subsection:last-child {
  margin-bottom: 0;
}

/* Chessboard pattern: even sections have text on the right */
.about-subsection:nth-child(even) .about-subsection-text {
  order: 2;
}

.about-subsection:nth-child(even) .about-subsection-image {
  order: 1;
}

.about-subsection-text {
  padding: 0 20px 20px 20px;
}

.about-subsection-text h2 {
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 30px;
  text-align: left;
  border-bottom: 3px solid #D4A574;
  padding-bottom: 15px;
}

.about-subsection-text h3 {
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  font-weight: 600;
  margin: 30px 0 15px 0;
  border-left: 4px solid #D4A574;
  padding-left: 15px;
}

.about-subsection-text p {
  color: #5D3A3A;
  line-height: 1.8;
  font-size: 1.1rem;
  margin-bottom: 20px;
  text-align: justify;
}

.about-subsection-text ul {
  margin: 20px 0;
  padding-left: 30px;
}

.about-subsection-text li {
  color: #5D3A3A;
  line-height: 1.8;
  font-size: 1.1rem;
  margin-bottom: 12px;
  text-align: justify;
}

.about-subsection-image {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
}

.about-subsection-image img {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.about-subsection-image img:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);
}

.about-video-container {
  margin-top: 60vh;
  width: 100%;
  max-width: 100%;
  position: relative;
}

.about-video {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.about-video::-webkit-media-controls {
  display: none !important;
}

.about-video::-webkit-media-controls-enclosure {
  display: none !important;
}

.about-video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0);
  opacity: 0;
  transition: opacity 0.3s ease, background 0.3s ease;
  cursor: pointer;
  border-radius: 12px;
}

.about-video-container:hover .about-video-overlay {
  opacity: 1;
  background: rgba(0, 0, 0, 0.2);
}

.video-play-pause-btn {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.video-play-pause-btn:hover {
  background: rgba(255, 255, 255, 1);
  transform: scale(1.1);
}

.video-play-pause-btn svg {
  width: 40px;
  height: 40px;
  fill: #7B2323;
}

/* Responsive About Us */
@media (max-width: 900px) {
  .about-subsection {
    grid-template-columns: 1fr;
    gap: 30px;
    margin-bottom: 60px;
  }
  
  /* Reset order for mobile - text always on top, image always below */
  .about-subsection:nth-child(even) .about-subsection-text,
  .about-subsection .about-subsection-text {
    order: 1;
  }
  
  .about-subsection:nth-child(even) .about-subsection-image,
  .about-subsection .about-subsection-image {
    order: 2;
  }
  
  .about-subsection-text h2 {
    font-size: 2rem;
  }
  
  .about-subsection-text h3 {
    font-size: 1.5rem;
  }
  
  .about-subsection-text p,
  .about-subsection-text li {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .about-section {
    padding: 40px 15px;
  }
  
  .about-subsection {
    margin-bottom: 50px;
    gap: 20px;
  }
  
  .about-subsection-text h2 {
    font-size: 1.8rem;
  }
  
  .about-subsection-text h3 {
    font-size: 1.3rem;
  }
  
  .about-subsection-text p,
  .about-subsection-text li {
    font-size: 0.95rem;
  }
}

.about-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin: 2.5rem 0 2rem 0;
}

.about-gallery img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 2px 12px #D7B89933;
  transition: transform 0.2s;
}

.about-gallery img:hover {
  transform: scale(1.04) rotate(-1deg);
  box-shadow: 0 6px 24px #7B232344;
}

.placeholder-section {
  background: #F7E9D2;
  border-radius: 18px;
  box-shadow: 0 2px 16px #D7B89933;
  padding: 2.5rem 2rem;
  margin-bottom: 2.5rem;
  text-align: center;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #5D3A3A;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #F7E9D2;
  border-top: 4px solid #D4A574;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid #DC3545;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  color: #721C24;
}

.retry-btn {
  background: #DC3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-top: 10px;
}

.retry-btn:hover {
  background: #C82333;
}

.no-products {
  text-align: center;
  padding: 60px 20px;
  color: #5D3A3A;
  font-size: 1.1rem;
}

.fallback-notice {
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid #FFC107;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  color: #856404;
}

.fallback-notice p {
  margin: 0;
}

/* Admin Button */
.admin-button {
  position: fixed;
  top: 80px;
  right: 20px;
  background: linear-gradient(135deg, #D4A574 0%, #C19A6B 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(212, 165, 116, 0.3);
  z-index: 1001;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.admin-button:hover {
  background: linear-gradient(135deg, #C19A6B 0%, #B08A5A 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 165, 116, 0.4);
}

.admin-button:active {
  transform: translateY(0);
}

/* Responsive admin button and header for tablets */
@media (max-width: 768px) {
  .admin-button {
    top: 70px;
    right: 15px;
    padding: 10px 16px;
    font-size: 0.9rem;
  }
  
  /* Reduce logo size on tablets */
  .header-logo {
    height: 70px;
    margin: 40px 0;
  }
  
  /* Reduce subtitle text size on tablets */
  .header-overlay p {
    font-size: 1.2rem;
    letter-spacing: 1.5px;
  }
}

@media (max-width: 480px) {
  .admin-button {
    top: 65px;
    right: 10px;
    padding: 8px 14px;
    font-size: 0.8rem;
  }
  
  /* Even smaller logo and text on very small mobile devices */
  .header-logo {
    height: 50px;
    margin: 25px 0 15px 0;
  }
  
  .header-overlay p {
    font-size: 0.75rem;
    letter-spacing: 0.5px;
  }
}

@media (max-width: 1100px) {
  .winery-header h1 {
    font-size: 2.5rem;
    letter-spacing: 2px;
  }
  
  .winery-header p {
    font-size: 1rem;
  }
  
  .catalogue-header h2 {
    font-size: 2rem;
  }
  
  .wine-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .winery-header h1 {
    font-size: 2.5rem;
    letter-spacing: 2px;
  }
  
  .winery-header p {
    font-size: 1rem;
  }
  
  .catalogue-header h2 {
    font-size: 2rem;
  }
  
  .wine-grid {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 0 20px;
  }
  
  .wine-grid:has(> :only-child) {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto;
  }
}

@media (max-width: 700px) {
  .header-photo-section {
    height: 220px;
  }
  .header-content h1 {
    font-size: 2rem;
    letter-spacing: 2px;
  }
  .header-content p {
    font-size: 1rem;
  }
  
  /* Smaller subtitle text on mobile */
  .header-overlay p {
    font-size: 0.9rem;
    letter-spacing: 1px;
  }
  
  /* Reduce logo size on mobile */
  .header-logo {
    height: 60px;
    margin: 30px 0 20px 0;
  }
  
  .about-gallery img {
    height: 120px;
  }
}

/* Shop Section */
.shop-section {
  padding: 40px 20px; /* Reduced from 80px */
  max-width: 1400px;
  margin: 0 auto;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  min-height: 100vh;
}

.catalogue-header {
  text-align: center;
  margin-bottom: 30px; /* Reduced from 60px */
}

/* Wine Filters */
.wine-filters {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 0 auto 40px auto;
  max-width: 600px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
}

.filter-group label {
  color: #3D1818;
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-select {
  padding: 10px 16px;
  border: 2px solid #D4A574;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  color: #3D1818;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.filter-select:hover {
  border-color: #C19A6B;
  box-shadow: 0 2px 8px rgba(212, 165, 116, 0.2);
}

.filter-select:focus {
  outline: none;
  border-color: #7B2323;
  box-shadow: 0 0 0 3px rgba(123, 35, 35, 0.1);
}

.catalogue-header h2 {
  font-size: 2.5rem; /* Reduced from 3rem */
  color: #3D1818;
  margin: 0 0 15px 0; /* Reduced from 20px */
  font-weight: 200;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-family: 'Playfair Display', serif;
  text-shadow: none;
}

.catalogue-header p {
  font-size: 1.1rem; /* Reduced from 1.2rem */
  color: #3D1818;
  margin: 0;
  font-weight: 300;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.wine-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  padding: 10px 0;
  max-width: 1400px;
  margin: 0 auto;
  align-items: stretch; /* Make all cards stretch to equal height */
}

/* Performance optimization: enable GPU acceleration for grid items */
.wine-grid > * {
  content-visibility: auto; /* Only render visible cards */
  contain-intrinsic-size: 350px 600px; /* Estimated size for better layout */
}

/* Ensure single products look good */
.wine-grid:has(> :only-child) {
  grid-template-columns: minmax(300px, 400px);
  justify-content: center;
  max-width: 400px;
  margin: 0 auto;
}

/* Responsive grid adjustments */
@media (max-width: 1200px) {
  .wine-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    align-items: stretch; /* Maintain equal heights */
  }
}

@media (max-width: 900px) {
  .wine-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    align-items: stretch; /* Maintain equal heights */
  }
}

@media (max-width: 768px) {
  .wine-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 20px;
    align-items: stretch; /* Maintain equal heights */
  }
  
  .wine-grid:has(> :only-child) {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto;
  }
}

/* Winery Section */
.winery-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  min-height: 100vh;
}

.winery-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.winery-content h2 {
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.winery-content p {
  color: #5D3A3A;
  font-size: 1.2rem;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.winery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
}

.winery-item {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.winery-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.winery-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 20px;
}

.winery-item h3 {
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.winery-item p {
  color: #5D3A3A;
  line-height: 1.6;
  margin: 0;
}

/* Find Us Section */
.find-us-section {
  padding: 40px 20px;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  min-height: 100vh;
}

.find-us-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.find-us-content h2 {
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.find-us-content p {
  color: #5D3A3A;
  font-size: 1.2rem;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.location-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
}

.location-item {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: left;
}

.location-item h3 {
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
  border-bottom: 2px solid #D4A574;
  padding-bottom: 10px;
}

.location-item p {
  color: #5D3A3A;
  line-height: 1.6;
  margin: 0 0 10px 0;
  text-align: left;
}

/* Responsive Design for Shop, Winery, and Find Us Sections */
@media (max-width: 768px) {
  .shop-section,
  .winery-section,
  .find-us-section {
    padding: 40px 15px;
  }
  
  .catalogue-header h2,
  .winery-content h2,
  .find-us-content h2 {
    font-size: 2rem;
  }
  
  .catalogue-header p,
  .winery-content p,
  .find-us-content p {
    font-size: 1rem;
  }
  
  .wine-filters {
    flex-direction: column;
    gap: 20px;
    max-width: 100%;
    padding: 0 10px;
  }
  
  .filter-group {
    width: 100%;
    min-width: auto;
  }
  
  .wine-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .winery-grid,
  .location-info {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

@media (max-width: 480px) {
  .shop-section,
  .winery-section,
  .find-us-section {
    padding: 30px 10px;
  }
  
  .catalogue-header h2,
  .winery-content h2,
  .find-us-content h2 {
    font-size: 1.8rem;
  }
  
  .wine-grid {
    gap: 20px;
  }
  
  .winery-item,
  .location-item {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4IAA4I;EAC5I,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B,EAAE,iCAAiC;EAC9D,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,2HAA2H;EAC3H,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4FAA4F;EAC5F,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gDAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,UAAU;EACV,mDAAmD;EACnD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA,oEAAoE;EACpE;;IAEE,QAAQ;EACV;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE;IACE,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA,yCAAyC;EACzC;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,4DAA4D;EAC5D;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB,EAAE,sBAAsB;EAC1C,iBAAiB;EACjB,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB,EAAE,sBAAsB;EACzC,cAAc;EACd,kBAAkB,EAAE,sBAAsB;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB,EAAE,wBAAwB;EAC3C,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB,EAAE,2CAA2C;AACnE;;AAEA,qEAAqE;AACrE;EACE,wBAAwB,EAAE,8BAA8B;EACxD,mCAAmC,EAAE,qCAAqC;AAC5E;;AAEA,qCAAqC;AACrC;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,oBAAoB,EAAE,2BAA2B;EACnD;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,oBAAoB,EAAE,2BAA2B;EACnD;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;IACf,oBAAoB,EAAE,2BAA2B;EACnD;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE;;;IAGE,kBAAkB;EACpB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;;;IAGE,kBAAkB;EACpB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  color: #3D1818;\n}\n\n.winery-header {\n  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);\n  color: #FAF6E7;\n  padding: 80px 20px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border-bottom: 4px solid #D7B899;\n  box-shadow: 0 8px 32px rgba(61, 24, 24, 0.15);\n}\n\n.winery-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 50%, #E9A6A1 0%, transparent 60%), radial-gradient(circle at 80% 20%, #D7B899 0%, transparent 60%);\n  opacity: 0.15;\n}\n\n.header-photo-section {\n  position: relative;\n  width: 100%;\n  height: 380px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px; /* Add small margin for visual separation from navbar */\n}\n\n.header-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 60%; /* Lifted higher */\n}\n\n.header-photo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 68%; /* Static position for fallback */\n  z-index: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.header-photo.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.header-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  text-align: center;\n}\n\n.header-logo {\n  height: 96px;\n  width: auto;\n  max-width: 480px;\n  margin: 50px 0 50px 0;\n  filter: brightness(0) saturate(100%) invert(95%) sepia(8%) saturate(624%) hue-rotate(333deg) brightness(102%) contrast(92%);\n  transition: filter 0.3s ease;\n}\n\n.header-overlay h1 {\n  font-size: 2.56rem;\n  color: #FAF6E7;\n  text-shadow: 0 4px 24px #3D1818, 0 1px 0 #7B2323;\n  margin: 0 0 18px 0;\n  letter-spacing: 4px;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: 300;\n  text-transform: uppercase;\n}\n\n.header-overlay p {\n  font-size: 1.5rem;\n  color: #F7E9D2;\n  text-shadow: 0 2px 8px #3D1818;\n  font-weight: 300;\n  letter-spacing: 2px;\n  margin: 0;\n  text-transform: uppercase;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.header-photo-bg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.header-photo-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background: linear-gradient(180deg, rgba(61,24,24,0.25) 0%, rgba(123,35,35,0.25) 100%); */\n  background: linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.18) 100%);\n}\n\n.header-content {\n  position: relative;\n  z-index: 3;\n  text-align: center;\n}\n\n.header-content h1 {\n  font-size: 3.2rem;\n  color: #FAF6E7;\n  text-shadow: 0 4px 24px #3D1818, 0 1px 0 #7B2323;\n  margin-bottom: 18px;\n  letter-spacing: 4px;\n  font-family: 'Playfair Display', serif;\n  font-weight: 400;\n}\n\n.header-content p {\n  font-size: 1.25rem;\n  color: #F7E9D2;\n  text-shadow: 0 2px 8px #3D1818;\n  font-weight: 300;\n  letter-spacing: 2px;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n/* About Us Section */\n.about-section {\n  padding: 60px 20px;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  min-height: 100vh;\n}\n\n/* Each subsection with text and image */\n.about-subsection {\n  max-width: 1200px;\n  margin: 0 auto 80px auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: start;\n}\n\n.about-subsection:last-child {\n  margin-bottom: 0;\n}\n\n/* Chessboard pattern: even sections have text on the right */\n.about-subsection:nth-child(even) .about-subsection-text {\n  order: 2;\n}\n\n.about-subsection:nth-child(even) .about-subsection-image {\n  order: 1;\n}\n\n.about-subsection-text {\n  padding: 0 20px 20px 20px;\n}\n\n.about-subsection-text h2 {\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin-top: 0;\n  margin-bottom: 30px;\n  text-align: left;\n  border-bottom: 3px solid #D4A574;\n  padding-bottom: 15px;\n}\n\n.about-subsection-text h3 {\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin: 30px 0 15px 0;\n  border-left: 4px solid #D4A574;\n  padding-left: 15px;\n}\n\n.about-subsection-text p {\n  color: #5D3A3A;\n  line-height: 1.8;\n  font-size: 1.1rem;\n  margin-bottom: 20px;\n  text-align: justify;\n}\n\n.about-subsection-text ul {\n  margin: 20px 0;\n  padding-left: 30px;\n}\n\n.about-subsection-text li {\n  color: #5D3A3A;\n  line-height: 1.8;\n  font-size: 1.1rem;\n  margin-bottom: 12px;\n  text-align: justify;\n}\n\n.about-subsection-image {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 20px;\n}\n\n.about-subsection-image img {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  border-radius: 16px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.about-subsection-image img:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);\n}\n\n.about-video-container {\n  margin-top: 60vh;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n}\n\n.about-video {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.about-video::-webkit-media-controls {\n  display: none !important;\n}\n\n.about-video::-webkit-media-controls-enclosure {\n  display: none !important;\n}\n\n.about-video-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0);\n  opacity: 0;\n  transition: opacity 0.3s ease, background 0.3s ease;\n  cursor: pointer;\n  border-radius: 12px;\n}\n\n.about-video-container:hover .about-video-overlay {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.video-play-pause-btn {\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.2s ease, background 0.2s ease;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n.video-play-pause-btn:hover {\n  background: rgba(255, 255, 255, 1);\n  transform: scale(1.1);\n}\n\n.video-play-pause-btn svg {\n  width: 40px;\n  height: 40px;\n  fill: #7B2323;\n}\n\n/* Responsive About Us */\n@media (max-width: 900px) {\n  .about-subsection {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    margin-bottom: 60px;\n  }\n  \n  /* Reset order for mobile - text always on top, image always below */\n  .about-subsection:nth-child(even) .about-subsection-text,\n  .about-subsection .about-subsection-text {\n    order: 1;\n  }\n  \n  .about-subsection:nth-child(even) .about-subsection-image,\n  .about-subsection .about-subsection-image {\n    order: 2;\n  }\n  \n  .about-subsection-text h2 {\n    font-size: 2rem;\n  }\n  \n  .about-subsection-text h3 {\n    font-size: 1.5rem;\n  }\n  \n  .about-subsection-text p,\n  .about-subsection-text li {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .about-section {\n    padding: 40px 15px;\n  }\n  \n  .about-subsection {\n    margin-bottom: 50px;\n    gap: 20px;\n  }\n  \n  .about-subsection-text h2 {\n    font-size: 1.8rem;\n  }\n  \n  .about-subsection-text h3 {\n    font-size: 1.3rem;\n  }\n  \n  .about-subsection-text p,\n  .about-subsection-text li {\n    font-size: 0.95rem;\n  }\n}\n\n.about-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n  margin: 2.5rem 0 2rem 0;\n}\n\n.about-gallery img {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px #D7B89933;\n  transition: transform 0.2s;\n}\n\n.about-gallery img:hover {\n  transform: scale(1.04) rotate(-1deg);\n  box-shadow: 0 6px 24px #7B232344;\n}\n\n.placeholder-section {\n  background: #F7E9D2;\n  border-radius: 18px;\n  box-shadow: 0 2px 16px #D7B89933;\n  padding: 2.5rem 2rem;\n  margin-bottom: 2.5rem;\n  text-align: center;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #5D3A3A;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #F7E9D2;\n  border-top: 4px solid #D4A574;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-message {\n  background: rgba(220, 53, 69, 0.1);\n  border: 1px solid #DC3545;\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  color: #721C24;\n}\n\n.retry-btn {\n  background: #DC3545;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  margin-top: 10px;\n}\n\n.retry-btn:hover {\n  background: #C82333;\n}\n\n.no-products {\n  text-align: center;\n  padding: 60px 20px;\n  color: #5D3A3A;\n  font-size: 1.1rem;\n}\n\n.fallback-notice {\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid #FFC107;\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  color: #856404;\n}\n\n.fallback-notice p {\n  margin: 0;\n}\n\n/* Admin Button */\n.admin-button {\n  position: fixed;\n  top: 80px;\n  right: 20px;\n  background: linear-gradient(135deg, #D4A574 0%, #C19A6B 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(212, 165, 116, 0.3);\n  z-index: 1001;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.admin-button:hover {\n  background: linear-gradient(135deg, #C19A6B 0%, #B08A5A 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(212, 165, 116, 0.4);\n}\n\n.admin-button:active {\n  transform: translateY(0);\n}\n\n/* Responsive admin button and header for tablets */\n@media (max-width: 768px) {\n  .admin-button {\n    top: 70px;\n    right: 15px;\n    padding: 10px 16px;\n    font-size: 0.9rem;\n  }\n  \n  /* Reduce logo size on tablets */\n  .header-logo {\n    height: 70px;\n    margin: 40px 0;\n  }\n  \n  /* Reduce subtitle text size on tablets */\n  .header-overlay p {\n    font-size: 1.2rem;\n    letter-spacing: 1.5px;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-button {\n    top: 65px;\n    right: 10px;\n    padding: 8px 14px;\n    font-size: 0.8rem;\n  }\n  \n  /* Even smaller logo and text on very small mobile devices */\n  .header-logo {\n    height: 50px;\n    margin: 25px 0 15px 0;\n  }\n  \n  .header-overlay p {\n    font-size: 0.75rem;\n    letter-spacing: 0.5px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .winery-header h1 {\n    font-size: 2.5rem;\n    letter-spacing: 2px;\n  }\n  \n  .winery-header p {\n    font-size: 1rem;\n  }\n  \n  .catalogue-header h2 {\n    font-size: 2rem;\n  }\n  \n  .wine-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .winery-header h1 {\n    font-size: 2.5rem;\n    letter-spacing: 2px;\n  }\n  \n  .winery-header p {\n    font-size: 1rem;\n  }\n  \n  .catalogue-header h2 {\n    font-size: 2rem;\n  }\n  \n  .wine-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    padding: 0 20px;\n  }\n  \n  .wine-grid:has(> :only-child) {\n    grid-template-columns: 1fr;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 700px) {\n  .header-photo-section {\n    height: 220px;\n  }\n  .header-content h1 {\n    font-size: 2rem;\n    letter-spacing: 2px;\n  }\n  .header-content p {\n    font-size: 1rem;\n  }\n  \n  /* Smaller subtitle text on mobile */\n  .header-overlay p {\n    font-size: 0.9rem;\n    letter-spacing: 1px;\n  }\n  \n  /* Reduce logo size on mobile */\n  .header-logo {\n    height: 60px;\n    margin: 30px 0 20px 0;\n  }\n  \n  .about-gallery img {\n    height: 120px;\n  }\n}\n\n/* Shop Section */\n.shop-section {\n  padding: 40px 20px; /* Reduced from 80px */\n  max-width: 1400px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  min-height: 100vh;\n}\n\n.catalogue-header {\n  text-align: center;\n  margin-bottom: 30px; /* Reduced from 60px */\n}\n\n/* Wine Filters */\n.wine-filters {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  margin: 0 auto 40px auto;\n  max-width: 600px;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 200px;\n}\n\n.filter-group label {\n  color: #3D1818;\n  font-weight: 600;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-select {\n  padding: 10px 16px;\n  border: 2px solid #D4A574;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  color: #3D1818;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.filter-select:hover {\n  border-color: #C19A6B;\n  box-shadow: 0 2px 8px rgba(212, 165, 116, 0.2);\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #7B2323;\n  box-shadow: 0 0 0 3px rgba(123, 35, 35, 0.1);\n}\n\n.catalogue-header h2 {\n  font-size: 2.5rem; /* Reduced from 3rem */\n  color: #3D1818;\n  margin: 0 0 15px 0; /* Reduced from 20px */\n  font-weight: 200;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  font-family: 'Playfair Display', serif;\n  text-shadow: none;\n}\n\n.catalogue-header p {\n  font-size: 1.1rem; /* Reduced from 1.2rem */\n  color: #3D1818;\n  margin: 0;\n  font-weight: 300;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.wine-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 25px;\n  padding: 10px 0;\n  max-width: 1400px;\n  margin: 0 auto;\n  align-items: stretch; /* Make all cards stretch to equal height */\n}\n\n/* Performance optimization: enable GPU acceleration for grid items */\n.wine-grid > * {\n  content-visibility: auto; /* Only render visible cards */\n  contain-intrinsic-size: 350px 600px; /* Estimated size for better layout */\n}\n\n/* Ensure single products look good */\n.wine-grid:has(> :only-child) {\n  grid-template-columns: minmax(300px, 400px);\n  justify-content: center;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n/* Responsive grid adjustments */\n@media (max-width: 1200px) {\n  .wine-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    align-items: stretch; /* Maintain equal heights */\n  }\n}\n\n@media (max-width: 900px) {\n  .wine-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    align-items: stretch; /* Maintain equal heights */\n  }\n}\n\n@media (max-width: 768px) {\n  .wine-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    padding: 0 20px;\n    align-items: stretch; /* Maintain equal heights */\n  }\n  \n  .wine-grid:has(> :only-child) {\n    grid-template-columns: 1fr;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n}\n\n/* Winery Section */\n.winery-section {\n  padding: 80px 20px;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  min-height: 100vh;\n}\n\n.winery-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.winery-content h2 {\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.winery-content p {\n  color: #5D3A3A;\n  font-size: 1.2rem;\n  margin-bottom: 40px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.winery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 40px;\n  margin-top: 40px;\n}\n\n.winery-item {\n  background: white;\n  border-radius: 16px;\n  padding: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.winery-item:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.winery-item img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 12px;\n  margin-bottom: 20px;\n}\n\n.winery-item h3 {\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.winery-item p {\n  color: #5D3A3A;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Find Us Section */\n.find-us-section {\n  padding: 40px 20px;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  min-height: 100vh;\n}\n\n.find-us-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.find-us-content h2 {\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.find-us-content p {\n  color: #5D3A3A;\n  font-size: 1.2rem;\n  margin-bottom: 40px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.location-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 40px;\n  margin-top: 40px;\n}\n\n.location-item {\n  background: white;\n  border-radius: 16px;\n  padding: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  text-align: left;\n}\n\n.location-item h3 {\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n  border-bottom: 2px solid #D4A574;\n  padding-bottom: 10px;\n}\n\n.location-item p {\n  color: #5D3A3A;\n  line-height: 1.6;\n  margin: 0 0 10px 0;\n  text-align: left;\n}\n\n/* Responsive Design for Shop, Winery, and Find Us Sections */\n@media (max-width: 768px) {\n  .shop-section,\n  .winery-section,\n  .find-us-section {\n    padding: 40px 15px;\n  }\n  \n  .catalogue-header h2,\n  .winery-content h2,\n  .find-us-content h2 {\n    font-size: 2rem;\n  }\n  \n  .catalogue-header p,\n  .winery-content p,\n  .find-us-content p {\n    font-size: 1rem;\n  }\n  \n  .wine-filters {\n    flex-direction: column;\n    gap: 20px;\n    max-width: 100%;\n    padding: 0 10px;\n  }\n  \n  .filter-group {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .wine-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n  \n  .winery-grid,\n  .location-info {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n}\n\n@media (max-width: 480px) {\n  .shop-section,\n  .winery-section,\n  .find-us-section {\n    padding: 30px 10px;\n  }\n  \n  .catalogue-header h2,\n  .winery-content h2,\n  .find-us-content h2 {\n    font-size: 1.8rem;\n  }\n  \n  .wine-grid {\n    gap: 20px;\n  }\n  \n  .winery-item,\n  .location-item {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
